@if (loaded) {
  <form
    [formGroup]="paymentTermForm"
    id="payment-term-form-container">
    <se-fe-grid seFeGridOpts="loose">
      <se-fe-grid-cell
        seFeGridOpts="1/1@mobile"
        class="top-element">
        @if (!disabled) {
          <se-fe-form-field [seFeDataConfig]="paymentTermFieldConfig">
            <se-fe-form-field-select
              formControlName="paymentTermSelect"
              (change)="selectTerm()"
              [seFeDataOptions]="paymentTermsList"
              seFeDataLabelKey="name"
              seFeDataValueKey="id"
              [seFeDataPlaceholder]="
                'PAYMENT_TERMS_SELECTOR.payment_term_placeholder' | translate
              "></se-fe-form-field-select>
            <span seFeHelp>{{ 'PAYMENT_TERMS_SELECTOR.DESCRIPTION.' + saleType | translate }}</span>
          </se-fe-form-field>
        }
        @if (!disabled) {
          <span seFePopoverTrigger="popoverPayment">
            <se-fe-popover seFePopoverName="popover">
              <div class="popover-text">
                {{ 'PAYMENT_TERMS_SELECTOR.popover' | translate }}
              </div>
            </se-fe-popover>
          </span>
        }
        @if (disabled) {
          <span
            [translate]="'PAYMENT_TERMS_SELECTOR.DISABLED.title'"
            seFePopoverTrigger="popoverDisabled"></span>
          <se-fe-popover seFePopoverName="popoverDisabled">
            <div class="popover-text">
              {{ 'PAYMENT_TERMS_SELECTOR.DISABLED.popover' | translate }}
            </div>
          </se-fe-popover>
        }

        @if (!disabled) {
          @if (addPaymentTerms) {
            <a
              seFeLink
              href="#"
              (click)="$event.preventDefault(); openPaymentTermsModal.emit(true)">
              {{ 'PAYMENT_TERMS_SELECTOR.add_terms_link' | translate }}
            </a>
          }
        }
      </se-fe-grid-cell>

      <se-fe-grid-cell seFeGridOpts="1/1@mobile">
        @if (paymentTerm) {
          <se-fe-grid seFeGridOpts="loose">
            <se-fe-grid-cell seFeGridOpts="1/1@mobile">
              <app-payment-term-summary [paymentTerm]="paymentTerm"></app-payment-term-summary>
            </se-fe-grid-cell>

            @if (showUpfrontAmountForm && !previewLoading) {
              <se-fe-grid-cell seFeGridOpts="1/1@mobile">
                <se-fe-grid seFeGridOpts="snug">
                  <se-fe-grid-cell seFeGridOpts="1/1@mobile 2/3@tablet">
                    <se-fe-grid seFeGridOpts="snug">
                      <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                        <se-fe-checkbox
                          seFeDataId="initialAmount"
                          formControlName="showPartialAmountInput"
                          (change)="toggleUpfrontPayment()">
                          <ng-template seFeFormFieldLabel>
                            {{ 'PAYMENT_TERMS_SELECTOR.PLAN_PREVIEW.UPFRONT_PAYMENT.label' | translate }}
                          </ng-template>
                        </se-fe-checkbox>
                      </se-fe-grid-cell>
                    </se-fe-grid>
                  </se-fe-grid-cell>
                  @if (showPartialAmountInput) {
                    <se-fe-grid-cell seFeGridOpts="1/1@mobile">
                      <app-upfront-payment-amount
                        [initialAmount]="initialAmount"
                        [paymentTermForm]="paymentTermForm"
                        [previewData]="previewData"
                        [totalAmount]="totalAmount"></app-upfront-payment-amount>
                    </se-fe-grid-cell>
                  }
                </se-fe-grid>
              </se-fe-grid-cell>
            }

            @if (previewLoading) {
              <se-fe-block>
                <div style="text-align: center">
                  <se-fe-spinner [seFeDataSize]="900"></se-fe-spinner>
                </div>
              </se-fe-block>
            }

            @if (!previewLoading && isInvoice) {
              <se-fe-grid-cell seFeGridOpts="1/1@mobile">
                <se-fe-grid seFeGridOpts="align-center">
                  <se-fe-grid-cell seFeGridOpts="1/1@mobile 3/4@tablet 2/3@desktop">
                    <app-payment-plan-preview
                      [paymentTerm]="paymentTerm"
                      [previewData]="previewData"
                      [paymentTermForm]="paymentTermForm"
                      [saleType]="saleType"
                      [itemized]="itemized"
                      [termSelectionDisabled]="disabled"
                      [showPartialAmountInput]="showPartialAmountInput"></app-payment-plan-preview>
                  </se-fe-grid-cell>
                </se-fe-grid>
              </se-fe-grid-cell>
            }

            @if (!isInvoice) {
              <se-fe-grid-cell seFeGridOpts="1/1@mobile">
                <se-fe-grid seFeGridOpts="align-center">
                  <se-fe-grid-cell seFeGridOpts="1/1@mobile 3/4@desktop">
                    <app-payment-term-preview
                      [paymentTerm]="paymentTerm"
                      [paymentTermForm]="paymentTermForm"
                      [saleType]="saleType"></app-payment-term-preview>
                  </se-fe-grid-cell>
                </se-fe-grid>
              </se-fe-grid-cell>
            }
          </se-fe-grid>
        }
      </se-fe-grid-cell>
    </se-fe-grid>
  </form>
}

@if (!loaded) {
  <se-fe-block>
    <div class="centered">
      <se-fe-spinner [seFeDataSize]="900"></se-fe-spinner>
    </div>
  </se-fe-block>
}
